module.exports = __webpack_public_path__ + "img/ic-map-minus-active.d41e8993.svg";